import { Spinner } from "@jobber/components/Spinner";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {jobberAccountName, jobberAuthorize, saveXeroAccounts} from "services";
import {showError} from "../../helpers";

const JobberCallback = () => {
  const [searchParams] = useSearchParams();
  const state = searchParams.get("state");
  const code = searchParams.get("code");
  const navigate = useNavigate();

  useEffect(() => {
    if (!code) {
      navigate("/error", { replace: true });
    }

    // xero -> jobber flow
    if (state) {
      (async () => {
        try {
          await jobberAuthorize(code, state);
          navigate("/xero-jobber-step2", { replace: true });
        } catch(e: any) {
          navigate("/error", { replace: true });
        }
      })();

    // jobber -> xero flow
    } else {
      (async () => {
        try {
          const { data: res } = await jobberAuthorize(code, null);
          sessionStorage.setItem('state', res.state);
          const { data: accountName } = await jobberAccountName(res.state);
          localStorage.setItem("account", accountName);
          navigate("/jobber-xero-step1", { replace: true });
        } catch(e: any) {
          navigate("/error", { replace: true });
        }
      })();
    }
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <Spinner />
      <h1>Jobber authentication in progress</h1>
    </div>
  );
};

export default JobberCallback;
